import type { TFunction } from "i18next";

const ACCESS_LABEL_KEYS: Record<string, string> = {
  FREE: "accessLevel.free",
  PRO: "accessLevel.pro",
  AI: "accessLevel.ai_tutor",
  "PRO + AI": "accessLevel.pro_ai",
  "ALL ACCESS": "accessLevel.all_access",
  "ALL ACCESS + AI": "accessLevel.all_access",
  "NO ACCESS": "accessLevel.no_access",
};

export function getLocalizedAccessLabel(
  t: TFunction,
  rawLabel: string,
): string {
  const key = ACCESS_LABEL_KEYS[rawLabel];
  return key ? t(key) : rawLabel;
}
